import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import vuetify from "./plugins/vuetify";
import Utils from "./plugins/utils";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'
import "leaflet-side-by-side";
import "./plugins/leaflet-side-by-side-vertical";
import "./common.css";
import VueClipboard from 'vue-clipboard2';

var Cesium = require("cesium/Cesium");

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

Vue.config.productionTip = false;

Vue.prototype.utils = Utils;
Vue.prototype.L = L;
Vue.prototype.Cesium = Cesium;
Vue.prototype.axios = axios;
Vue.prototype.eventVue = new Vue();
axios.defaults.timeout = 1000 * 60 * 30;
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})


/*import cgwx from "cgwxfrontmonitor";*/

// cgwx.registerLogger('pan-datadelivery')  //运营空间为自己的项目名称
// Vue.prototype.logInfo = cgwx.logInfo; //自定义函数全局挂载
// cgwx.registerMonitor('pan-datadelivery')  //运营空间为自己的项目名称


// 添加window层面的变量
window.viewer = "";
window.cesiumView = {
    googleImageLayer: "",
    bingImageLayer: "",
    tdtVectorLayer: "",
    tdtBzVectorLayer: "",
    tdtImageLayer: "",
    tdtBzImageLayer: "",
    drawOperatorFlag: "",    // 鼠标左键绘制的方式
    drawDataSource: "",      // 保存测量功能画出来的图形
    curMeasureIds: [],       // 保存绘制过程中的点的ID
    drawPolylinePath: [],    // 测距离：鼠标点过的点之3D直角坐标集
    drawPolyline: undefined, // 测距离：最后一点的3D坐标
    drawPolygonPath: [],     // 侧面积
    drawPolygon: undefined,  // 侧面积
    tooltip: {},             // 提示框
};

Vue.prototype.toCode = function (str)
{
    var key = "ABCDEFG012HIJKLMN345OPQRST6789UVWXYZ";
    var l = key.length;
    var a = key.split("");
    var s = "",b, b1, b2, b3;
    for (var i = 0; i <str.length; i ++) {
        b = str.charCodeAt(i);
        b1 = b % l;
        b = (b - b1) / l;
        b2 = b % l;
        b = (b - b2) / l;
        b3 = b % l;
        s += a[b3] + a[b2] + a[b1];
    }
    return s;
}


new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");
